module.exports = "/assets/6b131fad49869387e6f3203d230afdfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GR.png
// module id = 1415
// module chunks = 0